import React, {useEffect, useState} from 'react';

import {AgGridReact} from 'ag-grid-react'; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css"; // Mandatory CSS required by the grid
import 'ag-grid-enterprise';
import PropTypes from 'prop-types';

import ConditionalLink from "../../../components/ConditionalLink";
import {formatNumberToCurrency} from "../../../helpers/utils";

const getUrl = (managerID = '', name, assetId, tab) => {
    const urls = {
        "Base Rent": `/Asset/${assetId}/Tenant/${managerID}`,
        "BaseRent": `/Asset/${assetId}/Tenant/${managerID}`,
        "Turnover Rent": `/Asset/${assetId}/Tenant/${managerID}`,
        "TurnoverRent": `/Asset/${assetId}/Tenant/${managerID}`,
        "Service Charge": `/Asset/${assetId}/Tenant/${managerID}`,
        "ServiceCharge": `/Asset/${assetId}/Tenant/${managerID}`,
        "Cumulative Rent": `/Asset/${assetId}/Tenant/${managerID}`,
        "CumulativeRent": `/Asset/${assetId}/Tenant/${managerID}`,
        "Other Income": `/Asset/${assetId}/Tenant/${managerID}`,
        "OtherIncome": `/Asset/${assetId}/Tenant/${managerID}`,
        "Other Expenses": `/Asset/${assetId}/Tenant/${managerID}`,
        "OtherExpenses": `/Asset/${assetId}/Tenant/${managerID}`,
        "NOI": `/Asset/${assetId}/Tenant/${managerID}`,
        "Leasing Fee": `/Asset/${assetId}/Tenant/${managerID}`,
        "LeasingFee": `/Asset/${assetId}/Tenant/${managerID}`,
        "Fit Out": `/Asset/${assetId}/Tenant/${managerID}`,
        "FitOut": `/Asset/${assetId}/Tenant/${managerID}`,
        "Opex": `/Asset/${assetId}/OpexManager/${managerID}`,
        "Capex": `/Asset/${assetId}/CostManager/${managerID}`,
        "MLA": `/Asset/${assetId}/Tenant/${managerID}`,
        "Actuals": `/Asset/${assetId}/Actuals`
    };

    return name === 'forecastsList' ? urls[tab] : urls.Actuals;
};

const CHART_URLS = {
  "Base Rent": "/BaseRent/Details",
  "Turnover Rent": "/TurnoverRent",
  "Service Charge": "/ServiceCharge/Details",
  "Cumulative Rent": "/CumulativeRent/Details",
  "Other Income": "/OtherIncome/Details",
  "Total Income": "/TotalIncome/Details",
  "Leasing Fee": "/LeasingFee/Details",
  "Fit Out": "/FitOut/Details",
  "Opex": "/Opex/Details",
  "Capex": "/Capex/Details",
  "MLAs": "/MLA/Details",
  "NOI": "/NOI/Details"
};

function currencyFormatter(params) {
    return params.value === 0 ? '-' : formatNumberToCurrency(params.value, 'EUR', '€0', 0);
}

const TableActualsForecasts = ({data, name, tab, period = 'month', year, padding="20px"}) => {
    useEffect(() => {
        let defaultColumns = [
            {
                field: 'name',
                headerName: tab === 'NOI' || tab === 'Opex' || tab === 'Capex' || tab === 'OtherExpenses' || tab === 'OtherIncome' ? 'Item' : 'Tenant',
                cellRenderer: (props) => {
                    if (props.data === undefined) return null;

                    if (tab !== 'NOI') {
                      return (
                        <ConditionalLink to={getUrl(props.data.managerid, name, props.data.assetid, tab)} from="Tenants" condition>
                          {props.data.name}
                        </ConditionalLink>
                      );
                    } else {
                      const chartUrl = CHART_URLS[props.data.name];
                      if (chartUrl) {
                        return (
                          <ConditionalLink to={chartUrl} from="/" condition>
                            {props.data.name}
                          </ConditionalLink>
                        );
                      } else {
                        return props.data.name;
                      }
                    }
                },
                filter: 'agSetColumnFilter'
            },
            ...new Array(period === 'month' ? 12 : 5).fill().map((e, i) => {
                let d = new Date()
                d.setMonth(i)
                return {
                    field: i.toFixed(0),
                    headerName: period === 'month' ? d.toLocaleString('en-US', { month: 'short' }) : year + i,
                    cellRenderer: currencyFormatter,
                    filter: 'agNumberColumnFilter',
                }
            })
        ];
        if (tab !== 'CumulativeRent' && tab !== 'Cumulative Rent') {
            defaultColumns.splice(1, 0, {
                headerName: 'Total',
                cellStyle: {backgroundColor: 'lightgrey'},
                valueFormatter: (params) => {
                    let total = 0;
                    for (let i = 0; i < (period === 'month' ? 12 : 5); i++) {
                        total += params.data[i];
                    }

                    return formatNumberToCurrency(total, 'EUR', '-', 0);
                }
            })
        }

        setColDefs(defaultColumns);
    }, [tab, period, year]);

        let defaultColumns = [
            {
                field: 'name',
                headerName: tab === 'NOI' || tab === 'Opex' || tab === 'Capex' || tab === 'OtherExpenses' || tab === 'OtherIncome' ? 'Item' : 'Tenant',
                cellRenderer: (props) => {
                    if (props.data === undefined) return null;

                    return ( tab !== 'NOI' &&
                        <ConditionalLink to={getUrl(props.data.managerid, name, props.data.assetid, tab)} from="Tenants" condition>
                            {props.data.name}
                        </ConditionalLink> || props.data.name
                    );
                },
                filter: 'agSetColumnFilter'
            },
            ...new Array(period === 'month' ? 12 : 5).fill().map((e, i) => {
                let d = new Date()
                d.setMonth(i)
                return {
                    field: i.toFixed(0),
                    headerName: period === 'month' ? d.toLocaleString('en-US', { month: 'short' }) : year + i,
                    cellRenderer: currencyFormatter,
                    filter: 'agNumberColumnFilter',
                }
            })
        ];
        if (tab !== 'CumulativeRent') {
            defaultColumns.splice(1, 0, {
                headerName: 'Total',
                cellStyle: {backgroundColor: 'lightgrey'},
                valueFormatter: (params) => {
                    let total = 0;
                    for (let i = 0; i < (period === 'month' ? 12 : 5); i++) {
                        total += params.data[i];
                    }

                    return formatNumberToCurrency(total, 'EUR', '-', 0);
                }
            })
        }

        const [colDefs, setColDefs] = useState(defaultColumns);

        const autoSizeStrategy = {
            type: 'fitCellContents',
            // defaultMinWidth: 100,
        };
        return (
            <div
                className="ag-theme-quartz" // applying the grid theme
                style={{height: 500, padding}} // the grid will fill the size of the parent container
            >
                <AgGridReact
                    columnDefs={colDefs}
                    rowData={data.map((item) => {
                        if (item.actualsList) {
                            return {...item.actualsList, managerid: item.managerid, assetid: item.assetid, name: item.name, totals: item.totals}
                        }

                        return {...item.forecastsList, managerid: item.managerid, assetid: item.assetid, name: item.name, totals: item.totals}
                    })}
                    enableRangeSelection={true}
                    statusBar={{
                        statusPanels: [
                            {statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left'},
                            {
                                statusPanel: 'agAggregationComponent', statusPanelParams: {
                                    aggFuncs: ['avg', 'sum']
                                }
                            },
                        ]
                    }}
                    autoSizeStrategy={autoSizeStrategy}
                    getRowStyle={(params) => {
                        if (params.node.data.name === 'Total Income' || params.node.data.name === 'NOI') {
                            return { background: 'lightgrey' };
                        }
                    }}
                />
            </div>
        );
    }
;

export default TableActualsForecasts;

TableActualsForecasts.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    name: PropTypes.string.isRequired,
    tab: PropTypes.string.isRequired
};

TableActualsForecasts.defaultProps = {
    data: []
};
